<template>
  <div class="material-icons-round" :class="classes">
    <v-icon v-text="config.icon" class="material" :color="config.color" />
  </div>
</template>

<script>
/**
 * Common icons whihc are to be used throughtout the application
 */
export default {
  name: "CommonIcons",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    iconType: { type: String, required: true },
    classes: { type: String, default: "" },
  },
  /**
  |--------------------------------------------------
  | Computed properties
  |--------------------------------------------------
  */
  computed: {
    config() {
      const { commonIcons } = this.$appConfig;

      switch (this.iconType) {
        case commonIcons.error:
          return { color: "error", icon: "error_outline" };
        default:
          return { color: "error", icon: "error_outline" };
      }
    },
  },
};
</script>
